import { useMemo } from "react";
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Cell } from "recharts";
import { ChartCard } from "./ChartCard";

const COLORS = [
  "hsl(222, 47%, 35%)",
  "hsl(162, 73%, 35%)",
  "hsl(199, 89%, 48%)",
  "hsl(38, 92%, 50%)",
  "hsl(262, 52%, 47%)",
  "hsl(142, 76%, 36%)",
  "hsl(340, 65%, 47%)",
];

const CustomTooltip = ({ active, payload, label }) => {
  if (active && payload && payload.length) {
    return (
      <div className="bg-popover border border-border rounded-lg shadow-lg px-4 py-3">
        <p className="text-sm font-medium text-foreground">{label}</p>
        <p className="text-sm text-muted-foreground mt-1">
          <span className="font-semibold text-foreground">{payload[0].value}</span> opportunities
        </p>
      </div>
    );
  }
  return null;
};

export const TechAreaChart = ({ data }) => {
  const chartData = useMemo(() => {
    const techAreas = {};
    data.forEach(opp => {
      techAreas[opp.tech] = (techAreas[opp.tech] || 0) + 1;
    });

    return Object.entries(techAreas)
      .map(([name, count]) => ({ 
        name: name.length > 15 ? name.substring(0, 15) + "..." : name,
        fullName: name,
        count 
      }))
      .sort((a, b) => b.count - a.count);
  }, [data]);

  return (
    <ChartCard 
      title="Pipeline by Technology Area" 
      description="Distribution across technology domains"
    >
      <div className="h-[280px] mt-4">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart 
            data={chartData}
            layout="vertical"
            margin={{ top: 5, right: 30, left: 10, bottom: 5 }}
          >
            <CartesianGrid 
              strokeDasharray="3 3" 
              horizontal={true}
              vertical={false}
              stroke="hsl(var(--border))"
            />
            <XAxis 
              type="number"
              tick={{ fill: 'hsl(var(--muted-foreground))', fontSize: 12 }}
              axisLine={{ stroke: 'hsl(var(--border))' }}
            />
            <YAxis 
              dataKey="name" 
              type="category"
              tick={{ fill: 'hsl(var(--foreground))', fontSize: 11, fontWeight: 500 }}
              axisLine={{ stroke: 'hsl(var(--border))' }}
              width={110}
            />
            <Tooltip content={<CustomTooltip />} cursor={{ fill: 'hsl(var(--muted))', opacity: 0.5 }} />
            <Bar 
              dataKey="count" 
              radius={[0, 6, 6, 0]}
              maxBarSize={35}
            >
              {chartData.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
              ))}
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      </div>
    </ChartCard>
  );
};
